<ngx-skeleton-loader
	appearance="custom-content"
	animation="progress-dark"
	[theme]="{
		width: !webAppView ? '304px' : portalUser ? '360px' : 'auto',
		background: 'var(--portals-theme-highlight)'
	}"
	*ngIf="!notification || !notification?.channel?.name"
></ngx-skeleton-loader>

<ng-container *ngIf="isAppJotto">
	<div #jottoPreview [ngStyle]="{ 'width': !webAppView ? '304px' : '100%' }" class="jotto-container">
		<div class="notification-preview w-full" *ngIf="notification && notification?.channel?.name" [ngStyle]="{ 'background-color': !showStatus ? 'var(--portals-theme-card-background)' : color }">
			<div class="absolute top-0 right-0">
				<mat-chip class="status-label" *ngIf="showStatus" [ngStyle]="{ 'background-color': status == 'PENDING' ? 'var(--portals-theme-status-pending)' : status == 'LIVE' ? 'var(--portals-theme-status-live)' : status == 'DRAFT' ? 'var(--portals-theme-status-draft)' : status == 'EXPIRED' ? 'var(--portals-theme-status-expired)' : 'var(--portals-theme-status-archived)', color: status == 'EXPIRED' ? '#ffffff' : '#020D19' }">{{ status }}</mat-chip>
			</div>
			<div *ngIf="portalUser && !webAppView" class="header-label-wrapper">
				<img [src]="notification?.channel?.image?.url || 'assets/images/default.png'" alt="channel-thumbnail" />
				<div *ngIf="notification?.channel?.name" class="details">
					<h4 class="channel-name">
						{{ notification?.channel?.name }}
					</h4>
					<span class="channel-followers">{{ channelFollowers | count }} followers</span>
				</div>
			</div>
			<div *ngIf="webAppView; else portalView">
				<img *ngIf="(notification?.media?.image?.url || notification?.image?.url) && (!notification?.media?.video?.url || !notification?.video?.url)" [src]="notification.media?.image?.url || notification.image?.url" class="web-thumbnail" />
				<portals-video-player class="thumbnail video-thumbnail" *ngIf="notification?.external_video_url || notification.media?.video || notification?.video" [videoUrl]="notification?.external_video_url || notification.media?.video?.url || notification.video?.url" [videoPosterUrl]="notification?.image ? notification.image?.url : videoPoster" [videoHeight]="videoHeight"></portals-video-player>
			</div>
			<ng-template #portalView>
				<div class="w-[304px]">
					<img *ngIf="notification?.image?.url && !notification?.video?.url" [src]="notification.image?.url" class="thumbnail" />
					<portals-video-player class="thumbnail video-thumbnail" *ngIf="notification?.external_video_url || notification?.video" [videoUrl]="notification?.external_video_url || notification.video?.url" [videoPosterUrl]="notification?.image ? notification.image?.url : videoPoster" [videoHeight]="videoHeight"></portals-video-player>
				</div>
			</ng-template>
			<div class="notification-body">
				<div fxLayout="row" fxLayoutAlign="space-between center">
					<h2 *ngIf="notification?.title" class="title">
						{{ notification.title }}
					</h2>
				</div>
				<div class="time">
					<small>{{ notification.createdAt | date : 'EEEE MMM d y' }}</small>
				</div>
				<div class="notification-message">
					<p *ngIf="notification?.message" class="message notification-message">
						{{ notification.message }}
					</p>
					<a *ngIf="notification?.external_url && notification?.external_url_name" class="external-url" href="{{ notification.external_url }}" target="_blank">> {{ notification.external_url_name }}</a>
				</div>
				<h5 *ngIf="notification.allow_video_feedback" class="cta-text">{{ notification.cta }}</h5>
				<div class="main-container" *ngIf="notification.allow_video_feedback">
					<div class="secondary-container">
						<div (click)="videoResponse()" class="cta-wrapper" [style.background-color]="localStorage.getItem('notification-' + String(notification.id)) ? '#B18FCF' : '#5600AF'">
							<p class="cta-action">{{localStorage.getItem('notification-' + notification.id) ? this.currentLanguage === 'en' ? 'Jott Received' : 'Jott Recibido' : 'Jott us back!'}}</p>
						</div>
					</div>
					<img style="grid-column: 3/3; height: 20px; width: 20px;" *ngIf="localStorage.getItem('notification-' + notification.id)" src="assets/images/golden_check.png"/>
				</div>
				<div *ngIf="betaUser && notification && notification?.reactions?.length != 0">
					<h6 class="reaction-text">OR SEND US INSTANT FEEDBACK</h6>
					<div class="notification-actions">
						<div class="reactions">
							<div *ngFor="let reaction of notification?.reactions; let i = index">
								<div class="icon" [class.--auxiliary]="i != 0">
									<h2>{{ reaction.icon }}</h2>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="!isAppJotto">
	<div class="other-container">
		<div *ngIf="notification && notification?.channel?.name" [ngStyle]="{ width: !webAppView ? '300px' : portalUser ? '360px' : 'auto' }" class="notification-preview">
			<div class="header-label-wrapper">
				<img *ngIf="!webAppView" [src]="notification?.channel?.image?.url || 'assets/images/default.png'" alt="channel-thumbnail" />
				<h3 *ngIf="notification?.channel?.name" class="channel-name">
					{{ notification?.channel?.name }}
				</h3>
			</div>
			<h2 *ngIf="notification?.title" class="title">
				{{ notification.title }}
			</h2>
			<img *ngIf="notification?.image?.url" [src]="notification.image?.url" class="thumbnail" />
			<div class="notification-body">
				<p *ngIf="notification?.message" class="message notification-body">
					{{ notification.message }}
				</p>
			</div>
			<div (click)="webAppView ? videoResponse() : null" *ngIf="notification?.cta && notification.allow_video_feedback" class="cta-wrapper">
				<p class="cta">
					{{ notification.cta }}
					<span><fa-icon icon="video"></fa-icon></span>
				</p>
			</div>

			<div class="notification-actions">
				<div *ngIf="notification?.reactions" class="reactions">
					<div *ngFor="let reaction of notification?.reactions">
						<div class="icon">
							<h2>{{ reaction.icon }}</h2>
						</div>
					</div>
				</div>
				<a *ngIf="notification?.external_url && notification?.external_url_name" class="external-url" href="{{ notification.external_url }}" target="_blank">
					{{ notification.external_url_name }}
				</a>
			</div>
		</div>
	</div>
</ng-container>

<ng-template #responseDialog>
	<portals-notifications-response></portals-notifications-response>
</ng-template>
